<template>
  <div class="card mb-2 mt-2 ms-5 me-5">
    <div class="card-body">
      <h4 class="mt-3 mb-2">
        <strong>Servicios para la forma {{ imgFormName }}</strong>
      </h4>
      <div class="table-responsive">
        <table class="mx-auto">
          <tbody>
            <tr>
              <td class="lblform"><strong>Logitud de oxicorte:</strong></td>
              <td class="inputForm">
                <input id="profileAmountFlameCutting" type="number" min="0" step="50" class="form-control" placeholder="0"
                  :class="{ 'avilable-input': isFlameCutAvailable }" v-model="flameCuttingService"
                  :disabled="!isFlameCutAvailable" @change="calculateFlameCutting" />Digite en
                centímetros.
              </td>
              <td class="lblform">
                <strong>Cantidad de agujeros, punzonados <br />
                  o destijeres.</strong>Menores a 40mm:
              </td>
              <td class="inputForm">
                <input id="profileAmountPunched1" type="number" min="0" step="1" class="form-control" placeholder="0"
                  :class="{ 'avilable-input': isPunching1Available }" v-model="punching1Service"
                  :disabled="!isPunching1Available" @change="calculatePunching1" />Digite la
                cantidad.
              </td>
              <td class="lblform"><strong>Peso para rolado: </strong></td>
              <td class="inputForm">
                <input id="profileAmountRolled" type="number" min="0" step="1" class="form-control" placeholder="0"
                  :class="{ 'avilable-input': isRolledAvailable }" v-model="rolledService" :disabled="!isRolledAvailable"
                  @change="calculateRolled" />Digite en
                Kilos.
              </td>
              <td class="lblform"><strong>Longitud de soldadura con MIG:</strong></td>
              <td class="inputForm">
                <input id="profileAmountWeldingMig" type="number" min="0" step="50" class="form-control" placeholder="0"
                  :class="{ 'avilable-input': isWeldingMigAvailable }" v-model="weldingMigService"
                  :disabled="!isWeldingMigAvailable" @change="calculateWeldingMig" />Digite
                en centímetros.
              </td>
            </tr>
            <tr>
              <td class="lblform"><strong>Longitud de corte con plasma:</strong></td>
              <td class="inputForm">
                <input id="profileAmountPlasmaCutting" type="number" min="0" step="50" class="form-control"
                  placeholder="0" :class="{ 'avilable-input': isPlasmaAvailable }" v-model="plasmaCuttingService"
                  :disabled="!isPlasmaAvailable" @change="calculatePlasmaCutting" />Digite en centímetros.
              </td>
              <td class="lblform">
                <strong>Cantidad de agujeros, punzonados <br />o destijeres.</strong>
                Mayores a 40mm:
              </td>
              <td class="inputForm">
                <input id="profileAmountPunched2" type="number" min="0" step="1" class="form-control" placeholder="0"
                  :class="{ 'avilable-input': isPunching2Available }" v-model="punching2Service"
                  :disabled="!isPunching2Available" @change="calculatePunching2" />Digite la
                cantidad.
              </td>
              <td></td>
              <td></td>
              <td class="lblform"><strong>longitud de soldadura con electrodo:</strong></td>
              <td class="inputForm">
                <input id="profileAmountWeldingElectrode" type="number" min="0" step="50" class="form-control"
                  placeholder="0" :class="{ 'avilable-input': isWeldingElectrodeAvailable }"
                  v-model="weldingElectrodeService" :disabled="!isWeldingElectrodeAvailable"
                  @change="calculateWeldingElectrode" />Digite en
                centímetros.
              </td>
            </tr>
            <tr>
              <td class="lblform"><strong>Corte con láser:</strong></td>
              <td class="inputForm">
                <input id="profileAmountFlameCutting" type="number" min="0" step="50" class="form-control" placeholder="0"
                  :class="{ 'avilable-input': isLaserAvailable }" v-model="laserCuttingService"
                  :disabled="!isLaserAvailable" @change="calculateLaserCutting" />Digite en centímetros.
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td colspan="2" class="lblform">
                <p> <strong>Precio de otros servicios: </strong> <br> (Manipulación, transporte, embalaje, etc.)</p>
              </td>
              <td class="inputForm">
                <input id="profileAmountOther" type="number" min="0" class="form-control avilable-input" placeholder="0.0"
                  v-model="otherServices" step="1000" @change="calculateOtherServices" />Digite el
                valor en pesos.
              </td>
              <td></td>
              <td class="lblform">
                <strong>Observaciones adiconales:</strong>
              </td>
              <td colspan="3"><textarea id="profileComments" type="text"> </textarea></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
  props: {
    getProfileImageInfo: Object,
    getWeigthMeter: Number,
    getMainProfileType: Number,
  },
  watch: {
    getProfileImageInfo(newVal) {
      if (newVal != null) {
        this.assingServices();
      }
    },
    getMainProfileType(newVal) {
      if (newVal != null) {
        //console.log("profileType id:" + this.getMainProfileType);
        this.getProfileTypeById();
      }
    },
    totalServiceAmount(newTotalServiceAmount) {
      // Cuando totalServiceAmount cambia, actualiza totalService
      this.totalService = newTotalServiceAmount;
      // console.log(this.totalService);
      this.$emit("sendTotalServices", this.totalService);
    },

  },
  computed: {
    totalServiceAmount() {
      return (
        this.calculateFlameCutting() +
        this.calculatePlasmaCutting() +
        this.calculateLaserCutting() +
        this.calculatePunching1() +
        this.calculatePunching2() +
        this.calculateRolled() +
        this.calculateWeldingElectrode() +
        this.calculateWeldingMig() +
        this.calculateOtherServices()
      );
    },
  },
  data() {
    return {
      imgFormName: "",
      profileTypeInfo: [],
      totalService: 0,
      //Desahabilar los campos depedindode la disponibilidad del servicio
      isPlasmaAvailable: false,
      isLaserAvailable: false,
      isFlameCutAvailable: false,
      isRolledAvailable: false,
      isWeldingElectrodeAvailable: false,
      isWeldingMigAvailable: false,
      isPunching1Available: false,
      isPunching2Available: false,
      isOtherServices: true,
      //Services fields
      flameCuttingService: 0,
      plasmaCuttingService: 0,
      laserCuttingService: 0,
      weldingElectrodeService: 0,
      weldingMigService: 0,
      rolledService: 0,
      punching1Service: 0,
      punching2Service: 0,
      otherServices: 0,
    }
  },
  methods: {
    assingServices() {
      //console.log(this.getProfileImageInfo);
      // Información de servicios de acuerdo a la imagen
      this.imgFormName = this.getProfileImageInfo.imgFormName;
      this.getProfileImageInfo.imgServicePlasmaCutting === "aplica" ? this.isPlasmaAvailable = true : this.isPlasmaAvailable;
      this.getProfileImageInfo.imgServiceFlameCutting === "aplica" ? this.isFlameCutAvailable = true : this.isFlameCutAvailable;
      this.getProfileImageInfo.imgServiceLaserCutting === "aplica" ? this.isLaserAvailable = true : this.isLaserAvailable;
      this.getProfileImageInfo.imgServiceWeldingElectrode === "aplica" ? this.isWeldingElectrodeAvailable = true : this.isWeldingElectrodeAvailable;
      this.getProfileImageInfo.imgServiceWeldingMig === "aplica" ? this.isWeldingMigAvailable = true : this.isWeldingMigAvailable;
      this.getProfileImageInfo.imgServiceRolled === "aplica" ? this.isRolledAvailable = true : this.isRolledAvailable;
      this.getProfileImageInfo.imgServicePunching1 === "aplica" ? this.isPunching1Available = true : this.isPunching1Available;
      this.getProfileImageInfo.imgServicePunching2 === "aplica" ? this.isPunching2Available = true : this.isPunching2Available;
    },
    async getProfileTypeById() {
      if (this.getMainProfileType == 0) {
        console.log("Id de clasificación de perfil inválido.");
      } else {
        try {
          let res = await axios.get(RUTA_SERVIDOR + "api/profile/type/get", {
            params: {
              profile_type_id: this.getMainProfileType,
            },
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          });
          //console.log(res.data);
          if (!res.data) {
            console.log("There has been a different error with the data.");
          } else {
            console.log(res.data);
            this.profileTypeInfo = res.data[0];
            //this.callCalculateServices();
          }
        } catch (err) {
          console.log(`There has been an error ${err}`);
        }
      }
    },
    calculateFlameCutting() {
      if (this.isFlameCutAvailable) {
        return (this.flameCuttingService / 100) * this.profileTypeInfo.priceFlameCutting;
      } else {
        return 0;
      }
    },
    calculatePlasmaCutting() {
      if (this.isPlasmaAvailable) {
        return (this.plasmaCuttingService / 100) * this.profileTypeInfo.pricePlasmaCutting;
      } else {
        return 0;
      }
    },
    calculateLaserCutting() {
      if (this.isLaserAvailable) {
        return (this.laserCuttingService / 100) * this.profileTypeInfo.priceLaserCutting;
      } else {
        return 0;
      }
    },
    calculatePunching1() {
      if (this.isPunching1Available) {
        return (this.punching1Service * this.profileTypeInfo.pricePunching1);
      } else {
        return 0;
      }
    },
    calculatePunching2() {
      if (this.isPunching2Available) {
        return (this.punching2Service * this.profileTypeInfo.pricePunching2);
      } else {
        return 0;
      }
    },
    calculateRolled() {
      if (this.isRolledAvailable) {
        return this.rolledService * this.profileTypeInfo.priceRolled;
      } else {
        return 0;
      }
    },
    calculateWeldingElectrode() {
      if (this.isWeldingElectrodeAvailable) {
        return (this.weldingElectrodeService / 100) * this.profileTypeInfo.priceWeldingElectrode;
      } else {
        return 0;//console.log("El servicio no aplica")
      }
    },
    calculateWeldingMig() {
      if (this.isWeldingMigAvailable) {
        return (this.weldingMigService / 100) * this.profileTypeInfo.priceWeldingMig;
      } else {
        return 0;
      }
    },
    calculateOtherServices() {
      return this.otherServices;
    }
  }
};
</script>
<style scoped>
.card {
  border: solid 2px #a6323b;
}

input [type="number"] {
  padding: 2px 6px 2px 16px;
  border: solid 5px #999999;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}

textarea {
  min-width: 430px;
  min-height: 80px;
}

.avilable-input {
  background-color: #FCE196;
}
</style>
  